import { Component, ChangeDetectionStrategy, input } from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'
import { BaseButtonComponent } from '@/shared/components/base/base-button/base-button.component'
import { AuthService } from '@/services/auth.service'

@Component({
	selector: 'login-button',
	imports: [BaseButtonComponent, TranslocoDirective],
	templateUrl: './login-button.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './login-button.component.css'
})
export class LoginButtonComponent {
	readonly block = input(false)
	/** Success on the auth modals' light surface, where the design makes it the green call to action. */
	readonly variant = input<'secondary' | 'success'>('secondary')
	/** The login request in flight; authService.isLoading covers only the session setup after it. */
	readonly loading = input(false)

	constructor(
		public authService: AuthService
	) {}
}
